import React from 'react';

class SwitchProblem extends React.Component {
    render() {
        const {problems_count, index_counter, onNext, onPrevious} = this.props;
        
        if (!problems_count) {
            return (
                <p className="lead">Brak dostępnych spraw</p>
            )
        } 
        return(
            <div className="problem-controls text-right">
                <button onClick={onPrevious} className="btn btn-link">Poprzednie</button>
                <span className="mr-8">{index_counter} / {problems_count}</span>
                <button onClick={onNext} className="btn btn-primary">Następne pytanie</button>
            </div>
        )
    }
}

export default SwitchProblem;